import { useEffect } from 'react';
import { setAnalyserFftOrder, setAnalyserSmoothing } from '../analyserDsp';

export function useAnalyserConfig(analyser: AnalyserNode | null, fftOrder: number, smoothing: number) {
  useEffect(() => { setAnalyserFftOrder(analyser, fftOrder); }, [analyser, fftOrder]);
  useEffect(() => { setAnalyserSmoothing(analyser, smoothing); }, [analyser, smoothing]);
}
